import styled from 'styled-components'
export default styled.div`
  margin-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/components/FormGroup.js